"use strict";

exports.ReferralHttpRepository = void 0;
var _constants = require("../data/constants");
var _ReferralError = require("../data/errors/ReferralError");
var _sdkTypes = require("../data/sdk-types");
var _HttpRepository = require("./HttpRepository");
class ReferralHttpRepository extends _HttpRepository.HttpRepository {
  constructor() {
    super(_constants.REFERRAL_API_BASE_URL);
  }
  async getReferralAddressForSourceAddressAsync(sourceAddress) {
    const res = await this.getAsync("referral/affiliate/".concat(sourceAddress), {
      headers: {
        'x-api-key': _constants.REFERRAL_API_KEY
      }
    });
    if (!res || !res.address || !res.commissionPercentage) throw new _ReferralError.ReferralError('Affiliate not found for source address', {
      component: _sdkTypes.ErrorContextComponent.REFERRAL_GET_REFERRAL_ADDRESS_FOR_SOURCE_ADDRESS,
      description: 'Could not find an affiliate for the source address'
    });
    return {
      address: res.address,
      commissionPercentage: res.commissionPercentage
    };
  }
}
exports.ReferralHttpRepository = ReferralHttpRepository;